import "./index.css";
import { useTranslation } from "react-i18next";

export const ProductIntro = () => {
  const { t } = useTranslation();
  return (
    <div className="product-intro-bg">
      <h5>{t("TELL_US_ABOUT_PRODUCT")}</h5>
      <p>{t("PRODUCT_MAPPING_DESCRIPTION")}</p>
    </div>
  );
};
